<section class="w-screen max-w-full overflow-hidden rounded-2xl sm:max-w-128">
  <!-- Header -->
  <header class="flex items-center gap-4 divide-[#42465A] border-b p-4 sm:p-8">
    <div
      class="flex h-10 w-10 items-center justify-center rounded-full bg-primary"
    >
      <mat-icon
        class="text-white icon-size-6"
        color="primary"
        [svgIcon]="'heroicons_solid:check'"
      ></mat-icon>
    </div>
    <p class="text-default text-xl font-semibold leading-6">Welcome to Plus!</p>
  </header>
  <!-- Main -->
  <main class="p-4 sm:p-8">
    <div
      class="flex w-full flex-col divide-[#42465A] rounded-[0.625rem] border border-solid"
    >
      <div
        class="flex flex-row items-center justify-between gap-2 p-4"
        [ngClass]="{ 'divide-[#42465A] border-b border-solid': data.period }"
      >
        <span class="text-default text-base opacity-48">Your subscription</span>
        <span class="text-default text-lg font-medium">{{
          data.name || 'plus' | titlecase
        }}</span>
      </div>
      @if (data.period) {
        <div class="flex flex-row items-center justify-between gap-2 p-4">
          <span class="text-default text-base opacity-48">Valid through</span>
          <span class="text-default text-lg font-medium">{{
            data.period | date: 'longDate'
          }}</span>
        </div>
      }
    </div>
  </main>
  <!-- Footer -->
  <footer
    class="flex justify-end bg-gray-50 px-6 py-4 sm:justify-end dark:bg-black dark:bg-opacity-10"
  >
    <button mat-stroked-button (click)="matDialogRef.close()">
      Start using Plus
    </button>
  </footer>
</section>
